import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { RestApiService, PaginatedResponse } from "./rest-api.service";
import { Company, Project } from "../models/base.model";

@Injectable({
    providedIn: 'root'
})
export class ApiProjectService extends RestApiService {

    /**
     * Get paginated list of projects
     */
    public apiGetObjects(params: any): Observable<PaginatedResponse<Project>> {
        return this.getList('projects/', Project.parse, params);
    }

    /**
     * Get a single project by ID
     */
    public apiGetObject(id: any, params: any = {}): Observable<Project> {
        return this.getSingle(`projects/${id}/`, Project.parse, params);
    }

    /**
     * Create a new project
     */
    public apiPostObject(payload: any, params: any = {}): Observable<Project> {
        return this.postSingle('projects/', payload, Project.parse, params);
    }

    /**
     * Update an existing project
     */
    public apiPutObject(id: any, payload: any, params: any = {}): Observable<Project> {
        return this.putSingle(`projects/${id}/`, payload, Project.parse, params);
    }

    /**
     * Delete a project
     */
    public apiDeleteObject(id: any, params: any): Observable<any> {
        return this.deleteSingle(`projects/${id}/`, params);
    }

    /**
     * Update project metadata
     */
    public apiPostMeta(id: any, payload: any, params: any): Observable<Project> {
        return this.postSingle(`projects/${id}/meta/`, payload, Project.parse, params);
    }

    /**
     * Get paginated list of companies for a project
     */
    public apiGetCompanies(id: any, params: any): Observable<PaginatedResponse<Company>> {
        return this.getList(`projects/${id}/companies/`, Company.parse, params);
    }

    /**
     * Get paginated list of companies for a project
     */
    public apiGetPermissions(id: any, params: any): Observable<any> {
        return this.getRaw(`projects/${id}/permissions/`, params);
    }

    /**
     * Get service status for a project (raw response, no parsing)
     */
    public apiGetServiceStatus(id: any, params: any = {}): Observable<any> {
        return this.getRaw(`projects/${id}/service-status/`, params);
    }

}
